import { useCallback } from 'react';

import { LightfieldBrandMark } from '@/components/integrations/ProviderBrandMarks';
import { useOrg } from '@/contexts/OrgContext';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { useCanWrite } from '@/hooks/usePermissions';
import {
  VendorImportCard,
  type VendorImportWizardHandoff,
} from '@/lib/vendor-import';

import { LightfieldImportWizard } from './LightfieldImportWizard';

export function LightfieldImportCard() {
  const enabled = useFeatureFlag('lightfield_import');
  const { currentOrg } = useOrg();
  const orgId = currentOrg?.id;
  const canWrite = useCanWrite();

  const renderWizard = useCallback(
    (handoff: VendorImportWizardHandoff) => (
      <LightfieldImportWizard
        orgId={handoff.orgId}
        isOpen={handoff.isOpen}
        onClose={handoff.onClose}
        onImportCreated={handoff.onImportCreated}
      />
    ),
    []
  );

  if (!enabled) {
    return null;
  }

  return (
    <VendorImportCard
      orgId={orgId}
      title='Import from Lightfield'
      description='Paste your Lightfield API key to bring your accounts and contacts into Ahoy.'
      ctaLabel='Connect Lightfield'
      icon={<LightfieldBrandMark className='size-5 text-fg-primary' />}
      renderWizard={renderWizard}
      showCta={canWrite}
    />
  );
}
